import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

import { IconPower } from 'components/icons';
import { Tooltip } from 'components/common/Tooltip';

import { useAspenLogger } from 'hooks/useAspenLogger';
import { useAspenSocket } from 'hooks/useAspenSocket';

import { createCommand } from 'modules/aspenCommands';

import { AppLeaf } from 'types/common/leaf';

interface PowerProps {
  leaf: AppLeaf;
}

export const Power = ({ leaf }: PowerProps) => {
  const { logAspenEvent } = useAspenLogger();

  const powerState = leaf?.state?.power;
  const { sendCommand } = useAspenSocket();

  return (
    <Tooltip title="Power" placement="top">
      <IconButton
        aria-label="power"
        data-testid="button-power"
        onClick={() => {
          sendCommand({
            leaf,
            command: createCommand('power', powerState?.power === 'on' ? 'off' : 'on'),
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leaf?.id,
              interaction: 'power',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconPower sx={{ color: powerState?.power === 'on' ? colors.purple[500] : colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
